export const confUrl ={
    url:  'https://pat.isti.cnr.it/' // online
    //url:'http://localhost:4501'  //localhost
};
